import {redirect} from 'react-router-dom';
import { useAuthStore } from '../store/auth-store';

export function action() {
    useAuthStore.getState().logout();
    const auth = useAuthStore.getState().auth;
    console.log(auth);    
    return redirect('/')
}